import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IPatientClinicSummary } from '../../_interfaces/IPatientSpace';
import { PatientSpaceService } from '../../_services/patient-space/patient-space.service';

@Component({
  selector: 'app-patient-clinics',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './patient-clinics.component.html',
  styleUrl: './patient-clinics.component.scss',
})
export class PatientClinicsComponent implements OnInit {
  loading = true;
  rows: IPatientClinicSummary[] = [];

  constructor(private readonly patientSpaceService: PatientSpaceService) {}

  ngOnInit(): void {
    this.patientSpaceService.clinics().subscribe({
      next: (response: IPatientClinicSummary[]) => {
        this.rows = Array.isArray(response) ? response : [];
        this.loading = false;
      },
      error: () => {
        this.rows = [];
        this.loading = false;
      },
    });
  }
}
